import * as React from 'react'

export interface WorkflowFieldRestrictionItem {
  key: string
  label: string
  isDeleted?: boolean
  /** Render muted: toggled off in the Workflow Configurator, and not deleted. */
  isInactive?: boolean
  iconName?: string
}

export interface WorkflowFieldRestrictionState {
  /** Resolved entity items currently selected as restrictions */
  items: WorkflowFieldRestrictionItem[]
  /** Whether all possible items are selected (shows empty state) */
  isAllSelected: boolean
}

export interface WorkflowFieldRestrictionActions {
  /** Remove an item by key */
  remove: (key: string) => void
}

export interface WorkflowFieldRestrictionMeta {
  /** Label shown when all/none selected */
  emptyLabel?: string
}

interface WorkflowFieldRestrictionContextValue {
  state: WorkflowFieldRestrictionState
  actions: WorkflowFieldRestrictionActions
  meta: WorkflowFieldRestrictionMeta
}

export const WorkflowFieldRestrictionContext =
  React.createContext<WorkflowFieldRestrictionContextValue | null>(null)

export function useWorkflowFieldRestriction(): WorkflowFieldRestrictionContextValue {
  const context = React.useContext(WorkflowFieldRestrictionContext)
  if (!context) {
    throw new Error(
      'useWorkflowFieldRestriction must be used within a WorkflowFieldRestriction.Provider',
    )
  }
  return context
}
